import { useContext } from 'react';
import { UserContext } from '../context/user';
import { HotelContext } from '../context/hotel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { i18nValue } from '../functions';
const LinkToSection = ({ section, icon, btnDescription = null }) => {
    const { language } = useContext(UserContext)
    const { getUrlPath } = useContext(HotelContext)
    console.log('SECTION ', section)
    let title = i18nValue(section, 'title', language);
    let description = i18nValue(section, 'desc', language);
    const parser = new DOMParser();
    const doc = parser.parseFromString(description, 'text/html');
    description = doc.body.textContent || ""; // Retorna el textContent o una cadena vacía si es null        
    if (btnDescription) {
        description = btnDescription
    }
    return (
        <a href={getUrlPath(section.code)}>
            <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
                <div className="d-block text-center d-flex" style={{ justifyContent: "flex-start", alignItems: "center" }}>
                    <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <FontAwesomeIcon icon={icon} color="#FFF" style={{ fontSize: 14 }} />
                    </div>
                    <div className="ml-3 pr-5 text-left w-100">
                        <div className="mb-0">
                            <b style={{ color: "#555555" }}>{title}</b>
                        </div>
                        <div className="mb-0" style={{
                            fontSize: 14,
                            color: "#888",
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            height: 20
                        }}>
                            {description}
                        </div>
                    </div>
                </div>
            </div>
        </a>
    )
}

export default LinkToSection